import { API } from '@Providers';

export default async function (showAllKennels: boolean = false) {
  const endpoint = `/api/shelter/kennels/sites-all?showAllKennels=${showAllKennels}`;

  return API({ endpoint });
}
